import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './MapLegend.module.scss'
import { ReactComponent as Arrow } from 'images/arrows/arrow-down.svg'
import { ReactComponent as StarIcon } from 'images/competitor-pricing/star.svg'
import { BrandChip } from '../../brand-monograms'

const cx = classNames.bind(styles)

const MapLegendOpen = ({ showNearbyStationCompetitors }) => {
  const { t } = useTranslation(['translations'])

  return (
  <div className={cx('map-legend')}>
    <Arrow className={cx('close-arrow')} />
    <div style={{ padding: '13px 15px' }}>
      <div className={cx('legend-row')}>
        <div className={cx('legend-icon', 'cheaper')} />
        <span>{t('widgets.competitorPricing.lowerCompetitorPrice')}</span>
      </div>
      <div className={cx('legend-row')}>
        <div className={cx('legend-icon', 'match')} />
        <span>{t('widgets.competitorPricing.matchedCompetitorPrice')}</span>
      </div>
      <div className={cx('legend-row')}>
        <div className={cx('legend-icon', 'expensive')} />
        <span>{t('widgets.competitorPricing.higherCompetitorPrice')}</span>
      </div>
      <div className={cx('legend-row')}>
        <div className={cx('legend-icon', 'no-price-data')} />
        <span>{t('widgets.competitorPricing.missingPriceData')}</span>
      </div>
      <div className={cx('legend-row')}>
        <StarIcon className={cx('legend-star')} />
        <span>{t('widgets.competitorPricing.favourite')}</span>
      </div>
      {showNearbyStationCompetitors && (
        <>
          <div className={cx('legend-divider')} />
          <div className={cx('legend-row', 'legend-row-mk')}>
            <span className={cx('legend-mk-tracked')}>
              <BrandChip brand={{ key: 'shell' }} size={18} />
            </span>
            <span>{t('widgets.competitorPricing.trackedInYourList')}</span>
          </div>
          <div className={cx('legend-row', 'legend-row-mk')}>
            <span className={cx('legend-mk-nearby')}>
              <BrandChip brand={{ key: 'bp' }} size={16} muted />
            </span>
            <span>{t('widgets.competitorPricing.nearbyTapToAdd')}</span>
          </div>
        </>
      )}
    </div>
  </div>
)}

const MapLegendClose = () => {
  const { t } = useTranslation(['translations'])

  return (
  <div className={cx('map-legend')}>
    <Arrow className={cx('open-arrow')} />
    <div style={{ margin: '10px', textAlign: 'center' }}> {t('widgets.competitorPricing.mapLegend')} </div>
  </div>
)}

const MapLegend = ({ legendView, onToggle, showNearbyStationCompetitors }) => (
  <div data-testid="map-legend"
    onClick={() => {
      onToggle(legendView === 'open' ? 'close' : 'open')
    }}
  >
    {legendView === 'open' ? <MapLegendOpen showNearbyStationCompetitors={showNearbyStationCompetitors} /> : <MapLegendClose />}
  </div>
)

MapLegend.propTypes = {
  legendView: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  showNearbyStationCompetitors: PropTypes.bool,
}

MapLegend.defaultProps = {
  legendView: 'open',
}

export { MapLegend }
